import { render } from "./EventDetail.vue?vue&type=template&id=193f5704&scoped=true"
import script from "./EventDetail.vue?vue&type=script&lang=js"
export * from "./EventDetail.vue?vue&type=script&lang=js"

import "./EventDetail.vue?vue&type=style&index=0&id=193f5704&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-193f5704"

export default script